import axios from 'axios';

import { CHANGE_PASSWORD_V5 } from 'constants/constants';

export type ChangePasswordRequest = {
  old_password: string;
  new_password: string;
  new_password_confirmation: string;
  two_factor_code?: string;
};

/**
 * Change password request.
 * Requires Bearer token auth header
 */
export const changePassword = async (data: ChangePasswordRequest) => {
  const result = await axios.put(CHANGE_PASSWORD_V5, data);
  return result.data;
};
